// extracted by mini-css-extract-plugin
export default {"candidateTable":"styles_candidateTable__l036X","customBox":"styles_customBox__Rq3NF","contentBox":"styles_contentBox__hGrIV","headingBox":"styles_headingBox__Mwwjf"};